import downloadwhite from "../../assets/images/download-white.svg";
import downloadred from "../../assets/images/download-red.svg";
import bowcher from "../../assets/images/bowcher.webp";
import wakalaImage from "../../assets/images/nta-wakala.jpg";
import { handleWakalaDownload, openLeadCaptureDownload } from "../../utils/downloadHelpers";

const DownloadBrochure: React.FC<{ data?: any }> = ({ data }) => {
  const brochureTitle = data?.title || "Download";
  const brochureTitleHasHtml = /<\/?[a-z][\s\S]*>/i.test(brochureTitle);
  return (
  <>

    <div className="max-w-7xl mx-auto lg:px-6 md:px-10 px-4 md:py-8 py-5 flex flex-col md:flex-row items-center gap-10">
      {/* Text & Buttons */}
      <div className="flex-1">
        {brochureTitleHasHtml ? (
          <div className="xl:text-5xl md:text-4xl text-3xl font-extrabold mb-3 leading-tight" dangerouslySetInnerHTML={{ __html: brochureTitle }} />
        ) : (
          <h1 className="xl:text-5xl md:text-4xl text-3xl font-extrabold mb-3 leading-tight">
            <span className="text-primary-red">{brochureTitle} </span>
            <span className="text-primary-navyblue"> Brochure</span>
          </h1>
        )}
        <p className="mb-8 text-primary-gray text-base font-medium leading-7">
          {data?.description || "Join us on this journey as we share our expertise, ignite conversation"}
        </p>
        <div className="flex xl:flex-row flex-col gap-3 lg:w-[80%] md:w-full w-[90%] ">
          <button 
            type="button" 
            onClick={() => openLeadCaptureDownload({ fileUrl: data?.pdf_url || wakalaImage, title: "Download Brochure" })} 
            className="flex items-center justify-center gap-2 bg-primary-red px-4 lg:text-[18px] text-[14px] text-primary-white font-bold  py-2 hover:bg-primary-red transition"
          >
            <img src={downloadwhite} alt="downloadwhite" className="" />{" "}
            DOWNLOAD BROCHURE
          </button>
          <button type="button" onClick={() => handleWakalaDownload(data?.pdf2_url || wakalaImage)} className="flex items-center justify-center gap-2 border-[#E74C3C] px-4 lg:text-[18px] text-[14px] border-[3px] text-primary-red font-bold py-2 hover:shadow-md transition">
            <img src={downloadred} alt="downloadred" className="" /> {data?.pdf2_label || "DOWNLOAD SAUDI WAKALA"}
          </button>
        </div>
      </div>
      {/* Illustration - replace with actual image */}
      <div>
        <img
          src={data?.image_url || bowcher}
          alt="Brochure Illustration"
          className="w-full lg:h-[300px] h-[280px]"
        />
      </div>
    </div>
  </>
);
};

export default DownloadBrochure;
